import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-grow pt-5 grid grid-cols-2 gap-3" }
const _hoisted_2 = { class: "flex flex-col mb-3 col-span-2" }
const _hoisted_3 = { class: "flex flex-col mb-3" }
const _hoisted_4 = { class: "flex flex-col mb-3" }
const _hoisted_5 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
    backdrop: true
  }, {
    header: _withCtx(() => _cache[5] || (_cache[5] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-lg font-bold" }, "Aggiungi riga di pagamento")
      ], -1)
    ])),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            field_name: "Tipo Effetto",
            required: !_ctx.tipoEffettoAutocomplete?.selection,
            errors: _ctx.getErrors('tipo_effetto_id'),
            placeholder: "Tipo Effetto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                loading: _ctx.tipoEffettoAutocomplete.isLoading,
                options: _ctx.tipoEffettoAutocomplete.options,
                modelValue: _ctx.tipoEffettoAutocomplete.selection,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipoEffettoAutocomplete.selection) = $event)),
                internal: "",
                "close-on-select": true,
                "clear-on-select": true,
                "track-by": "RDT00_CODEFFETTO",
                label: "RDT00_DESCEFFETTO",
                class: "next-vue-multiselect-single",
                placeholder: "Tipo Effetto",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                _: 1
              }, 8, ["loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            field_name: "Data scadenza",
            required: !_ctx.int_data_scadenza,
            modelValue: _ctx.int_data_scadenza,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.int_data_scadenza) = $event)),
            type: "date",
            errors: _ctx.getErrors('data_scadenza')
          }, null, 8, ["required", "modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            field_name: "Valore",
            required: !_ctx.int_valore,
            modelValue: _ctx.int_valore,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.int_valore) = $event)),
            type: "number",
            inputAttrs: {step:0.01},
            errors: _ctx.getErrors('valore')
          }, null, 8, ["required", "modelValue", "errors"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "col-start-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _ctx.save,
          disabled: _ctx.loading,
          class: "ml-4 py-2 px-4 flex items-center"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
              [_vShow, _ctx.loading]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.id ? 'Modifica' : 'Aggiungi'), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}